module.exports = __webpack_public_path__ + "static/media/view.2f259754.svg";